import { ReduxAction } from '../types';
import { BravoUser } from '../../bravoTypes';

interface TokenAction extends ReduxAction {
    type: "user.token";
    payload: string|null;
}
export const setToken:((t:string|null)=>TokenAction) = (token:string|null) => ({
    type: "user.token", 
    payload: token
});

interface ProfileAction extends ReduxAction {
    type: "user.profile";
    payload: BravoUser | null;
}
export const fetchProfile:(p:BravoUser | null)=>ProfileAction = (profile:BravoUser | null) => ({
    type:  "user.profile",
    payload: profile
});

interface PreferredBandAction extends ReduxAction {
    type: "user.preferredBand";
    payload:string;
}
export const setPreferredBand:(b:string)=>PreferredBandAction = (bandId:string) => ({
    type: "user.preferredBand",
    payload: bandId
});

export type UserAction = TokenAction | ProfileAction | PreferredBandAction;